import { readTenant, TenantInfo } from '../components/TopBar/TopBar.Functions';

/**
 * Tenant por id, desde Identity.
 *
 * Es el mismo servidor contra el que se hace el login —la app ya pide el scope
 * `IdentityServerApi`—, y es donde vive la información del tenant: el portal de
 * pacientes la consulta ahí (`api/v1/tenant/patient/{documento}`). La ruta por id
 * existe (responde 401 sin credenciales, mientras que una inexistente da 404), pero
 * no está documentada, así que la lectura de la respuesta es tolerante.
 */
const IdentityBaseUrl = (process.env.REACT_APP_AUTHENTICATION_AUTHORITY || 'https://identity.hc.alpha-cr.com').replace(/\/$/, '');

export const GetTenantById = async (tenantId: string, token: string): Promise<TenantInfo | undefined> => {
    const response = await fetch(`${IdentityBaseUrl}/api/v1/tenant/${encodeURIComponent(tenantId)}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token
        }
    });

    if (!response.ok) {
        throw new Error(`No se pudo obtener el tenant (${response.status})`);
    }

    return readTenant(await response.json(), tenantId);
};
